import { useEffect, useState } from 'react';

export const usePricing = isAuthenticated => {
  const [userPlan, setUserPlan] = useState('free');

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (!isAuthenticated) {
        setUserPlan('free');
        return;
      }

      try {
        const response = await fetch('/api/pricing/user', {
          credentials: 'include',
        });

        if (response.ok) {
          const pricingData = await response.json();
          setUserPlan(pricingData.pricing_plan || 'free');
        } else {
          console.error('Failed to fetch user pricing:', response.statusText);
          setUserPlan('free');
        }
      } catch (error) {
        console.error('Error fetching user pricing:', error);
        setUserPlan('free');
      }
    };

    fetchUserPlan();
  }, [isAuthenticated]);

  return {
    userPlan,
  };
};
